import React from "react";
import { HomeHospitalSlots } from "./HomeHospitalSlots";
import { NearbyLocationsSection } from "./NearbyLocationsSection";

export const TimeSelectionStep = () => (
  <div className="w-full flex flex-col gap-4">
    <HomeHospitalSlots />
    <NearbyLocationsSection />
  </div>
);
